<div class="empty-state-wrap">
  <div class="empty-state-card">

    <div class="empty-state-icon">
      <img class="empty-state-img" src="/assets/e-commerce/icons/44.webp" alt="empty" />
    </div>

    <h2 class="empty-state-title">
      {{ "No products" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "Start shopping now and discover our best offers" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/Home">
      {{ "shopping" | transloco }}
    </button>
  </div>
</div>